import { useAuth } from '../context/AuthContext';

/**
 * Pure derivation of the top-bar tab list from the current auth state.
 * Each descriptor:
 *   { id, label, to, match(path) -> bool, kind?: 'link' | 'dropdown', items?, variant? }
 */
export function useNavSections() {
    const { isAdmin, isFacilityAdmin, facilityId } = useAuth();

    const sections = [];

    // Overview leads for facility admins — it's their default landing view.
    if (isFacilityAdmin && facilityId) {
        sections.push({
            id: 'dashboard',
            label: 'Overview',
            to: `/facility/${facilityId}/dashboard`,
            match: (path) => path === `/facility/${facilityId}/dashboard`,
        });
    }

    sections.push({
        id: 'cases',
        label: 'Cases',
        to: '/cases',
        match: (path) => path === '/cases' || path.startsWith('/case/'),
    });

    if (isFacilityAdmin && facilityId) {
        sections.push({
            id: 'team',
            label: 'Team',
            to: `/facility/${facilityId}/team`,
            match: (path) => path === `/facility/${facilityId}/team`,
        });
    }

    if (isAdmin) {
        sections.push({
            id: 'platform',
            label: 'Platform',
            kind: 'dropdown',
            variant: 'platform',
            match: (path) => path.startsWith('/admin'),
            items: [
                { id: 'users',      label: 'Users',      to: '/admin?tab=users' },
                { id: 'invites',    label: 'Invites',    to: '/admin?tab=invites' },
                { id: 'metrics',    label: 'Metrics',    to: '/admin?tab=metrics' },
                { id: 'waitlist',   label: 'Waitlist',   to: '/admin?tab=waitlist' },
                { id: 'feedback',   label: 'Feedback',   to: '/admin?tab=feedback' },
                { id: 'facilities', label: 'Facilities', to: '/admin?tab=facilities' },
                { id: 'workflows',  label: 'Workflows',  to: '/admin/workflows' },
            ],
        });
    }

    return sections;
}
